import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { GdrpPopupComponent } from './gdrp-popup.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [GdrpPopupComponent],
  exports: [GdrpPopupComponent],
  providers: [],
})
export class GdrpPopupComponentModule {}
